import Services from 'store/Services';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'store/store';
import {
    isPortfolioSetSelectionAction,
    PortfolioActionType,
} from 'portfolio/store/actions';
import { AppSettingsActionType } from 'app/store/appSettings/actions';
import {
    isLoadWidgetConfigAction,
    isSetWidgetConfigAction,
} from 'widgets/store/configuration/actions';
import { isSetWidgetComponentStateAction } from 'widgets/store/component/actions';
import { OrdersActionType } from 'app/store/orders/actions';

export const widgetStreamingMiddleware = (services: Services) => [
    checkPortfolioSelectionDependentStreamsOnChange(services),
    checkStreamsOnAppSettingsChange(services),
    checkStreamsOnActiveInputChange(services),
    checkStreamsOnWidgetConfigChanged(services),
    checkStreamsOnWidgetComponentStateChanged(services),
    checkStreamsOnStreamingOrderIdsChanged(services),
];

export function checkPortfolioSelectionDependentStreamsOnChange(
    services: Services
) {
    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        const { widgetStreamingService } = services;

        next(action);

        if (isPortfolioSetSelectionAction(action)) {
            widgetStreamingService.checkPortfolioSelectionStreams();
        }
    };
}

export function checkStreamsOnAppSettingsChange(services: Services) {
    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        const { widgetStreamingService } = services;

        next(action);

        if (
            action.type === AppSettingsActionType.UPDATE ||
            action.type === AppSettingsActionType.LOAD
        ) {
            widgetStreamingService.checkAppSettingsDependentStreams();
        }
    };
}

export function checkStreamsOnActiveInputChange(services: Services) {
    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        const { widgetStreamingService } = services;

        next(action);

        if (action.type === PortfolioActionType.PORTFOLIO_SET_ACTIVE_INPUT) {
            widgetStreamingService.checkAllStreams('Active Input Change');
        }
    };
}

export function checkStreamsOnWidgetConfigChanged(services: Services) {
    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        const { widgetStreamingService } = services;

        next(action);

        if (
            isSetWidgetConfigAction(action) ||
            isLoadWidgetConfigAction(action)
        ) {
            widgetStreamingService.checkWidgetConfigDependentStreams(
                action.payload!.widgetType,
                action.payload!.widgetKey
            );
        }
    };
}

export function checkStreamsOnWidgetComponentStateChanged(services: Services) {
    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        const { widgetStreamingService } = services;

        next(action);

        if (isSetWidgetComponentStateAction(action)) {
            widgetStreamingService.checkWidgetComponentStateDependentStreams(
                action.payload!.widgetType,
                action.payload!.widgetKey
            );
        }
    };
}

export function checkStreamsOnStreamingOrderIdsChanged(services: Services) {
    return () => (next: ThunkDispatch<AnyAction>) => (action: AnyAction) => {
        const { widgetStreamingService } = services;

        next(action);

        if (
            action.type === OrdersActionType.ORDERS_UPDATE_STREAMING_ORDER_IDS
        ) {
            widgetStreamingService.checkOrderIdsDependentStreams();
        }
    };
}
